import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {filteringInstutionRole, institutionUserRole, InstutionRole} from './instution-role.model';

export const loadInstutionRoles = createAction(
  '[InstutionRole/API] Load InstutionRoles',
  props<{ instutionRoles: InstutionRole[] }>()
);

export const addInstutionRole = createAction(
  '[InstutionRole/API] Add InstutionRole',
  props<{ instutionRole: InstutionRole }>()
);

export const upsertInstutionRole = createAction(
  '[InstutionRole/API] Upsert InstutionRole',
  props<{ instutionRole: InstutionRole }>()
);

export const addInstutionRoles = createAction(
  '[InstutionRole/API] Add InstutionRoles',
  props<{ instutionRoles: InstutionRole[] }>()
);

export const upsertInstutionRoles = createAction(
  '[InstutionRole/API] Upsert InstutionRoles',
  props<{ instutionRoles: InstutionRole[] }>()
);

export const updateInstutionRole = createAction(
  '[InstutionRole/API] Update InstutionRole',
  props<{ instutionRole: Update<InstutionRole> }>()
);

export const updateInstutionRoles = createAction(
  '[InstutionRole/API] Update InstutionRoles',
  props<{ instutionRoles: Update<InstutionRole>[] }>()
);

export const deleteInstutionRole = createAction(
  '[InstutionRole/API] Delete InstutionRole',
  props<{ id: string }>()
);

export const deleteInstutionRoles = createAction(
  '[InstutionRole/API] Delete InstutionRoles',
  props<{ ids: string[] }>()
);

export const clearInstutionRoles = createAction(
  '[InstutionRole/API] Clear InstutionRoles'
);

//CUSTOM


export const createInstutionUserRole = createAction(
  '[InstutionRole/API] Create Instution User Roles',
  props<{ input?:institutionUserRole }>()
);


export const updateInstutionUserRole = createAction(
  '[InstutionRole/API] Update Instution User Roles',
  props<{ input?:institutionUserRole }>()
);


export const deleteUserRole = createAction(
  '[InstutionRole/API] delete Instution User Roles',
  props<{ roleUniqueId?:string,id:string }>()
);


export const getRoles = createAction(
  '[InstutionRole/API] get Instution  User Roles',
  props<{ filtering?:filteringInstutionRole }>()
);
